const OFFSET_BOX_SELECTOR = '[data-offset-box]';

export const useOffsetBoxes = (offsetBoxSelector = null) => {
  const offsetBoxItems = document.querySelectorAll(
    offsetBoxSelector || OFFSET_BOX_SELECTOR
  );

  offsetBoxItems.forEach((box) => {
    const relatedItem = box.dataset.offsetBox
      ? document.querySelector(
          `[data-offset-related="${box.dataset.offsetBox}"]`
        )
      : null;

    const itemHeight = relatedItem ? relatedItem.offsetHeight : 0;

    box.style.height = `${itemHeight}px`;
  });

  return true;
};

export const calcOffsetBoxesSize = () => {
  const offsetBoxesEls = document.querySelectorAll(OFFSET_BOX_SELECTOR);
  const offsetBoxesHeightValues = Array.from(offsetBoxesEls).map(
    (offsetBoxesEl) => (offsetBoxesEl ? offsetBoxesEl.clientHeight : 0)
  );

  return offsetBoxesHeightValues.reduce(
    (sum, offsetBoxesHeightValue) => sum + offsetBoxesHeightValue,
    0
  );
};

export const calcOffsetBoxesSizeWithoutHeaderOffer = (isScrollDown) => {
  const headerOffer = document.querySelector('[data-section-top-header-offer]');
  const headerDesktopNavigationMain = document.querySelector(
    '[data-theme-header-navigation-main]'
  );
  const headerOfferHeight = headerOffer ? headerOffer.clientHeight : 0;
  const headerDesktopNavigationMainOfferHeight = headerDesktopNavigationMain
    ? headerDesktopNavigationMain.clientHeight
    : 0;
  const isExistProductBuyBanner = Boolean(
    document.querySelector('[data-product-buy-banner]')
  );

  if (isScrollDown && !isExistProductBuyBanner) {
    return (
      calcOffsetBoxesSize() -
      headerOfferHeight -
      headerDesktopNavigationMainOfferHeight
    );
  }
  return calcOffsetBoxesSize() - headerOfferHeight;
};
